import { handleAxiosError } from "../utils/errorHandler";
import axiosInstance from "./axiosInstance";
export const fetchAvailableYears = async () => {
  try {
    const response = await axiosInstance.get(`/api/invoices/years`);
    return { success: true, data: response.data };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání dostupných let."
    );
    return { success: false, status, message };
  }
};

export const fetchFaktury = async (year, limit) => {
  try {
    const response = await axiosInstance.get(`/api/invoices`, {
      params: { year, limit },
    });

    const fakturyData =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    return { success: true, data: fakturyData };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání faktur."
    );
    return { success: false, status, message };
  }
};

export const fetchGraphData = async (idOdberneMisto) => {
  try {
    const response = await axiosInstance.get(
      `/api/collection-points/graph/${idOdberneMisto}`
    );

    const fakturyData =
      typeof response.data === "string"
        ? JSON.parse(response.data)
        : response.data;

    return { success: true, data: fakturyData };
  } catch (error) {
    const { status, message } = handleAxiosError(
      error,
      "Chyba při načítání faktur."
    );
    return { success: false, status, message };
  }
};
